import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-top-lined",
  "use": "rt-base-top-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-top-lined\"><path d=\"M518.3 339c-3.2-4.1-9.4-4.1-12.6 0l-112 141.8c-4.1 5.2-0.4 12.9 6.3 12.9h71.9V840c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V493.6H624c6.7 0 10.4-7.7 6.3-12.9L518.3 339zM112 176h800v80H112z\" p-id=\"6471\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/top-lined.svg
// module id = 1759
// module chunks = 228